export const LEARN_SLUGS = [
  { slug: "what-is-high-blood-pressure", title: "What Is High Blood Pressure?" },
  { slug: "what-is-diabetes", title: "What Is Diabetes?" },
  { slug: "what-is-erectile-dysfunction", title: "What Causes Erectile Dysfunction?" },
  { slug: "what-is-high-cholesterol", title: "What Does High Cholesterol Mean?" },
  { slug: "what-is-sciatica", title: "What Is Sciatica?" },
  { slug: "what-is-testosterone", title: "What Is Testosterone?" },
  { slug: "what-is-atrial-fibrillation", title: "What Is Atrial Fibrillation?" },
  { slug: "what-is-a-normal-blood-sugar", title: "What Is a Normal Blood Sugar?" },
  { slug: "what-is-an-mri", title: "What Is an MRI?" },
  { slug: "what-is-eczema", title: "What Is Eczema?" },
  { slug: "metformin-side-effects", title: "Metformin Side Effects" },
  { slug: "sildenafil-side-effects", title: "Sildenafil Side Effects" },
];

export const KNOWN_SLUGS = LEARN_SLUGS.map((s) => s.slug);
